import axios from "axios";
import { COUNTRY } from "../config/market.js";

const BASE_URL = process.env.REACT_APP_SERVER_URL; //Both ProdEnv & DevNgrok

const isLocalApiRequest = (config = {}) => {
  const url = config.url || "";
  if (!url || url.startsWith("/")) return true;
  return Boolean(BASE_URL && url.startsWith(BASE_URL));
};

const hasCountryQuery = (url = "") => /(?:[?&])country=/i.test(url);

export const withMarketScope = (config = {}) => {
  config.headers = config.headers || {};
  // ONE header only. Setting both "x-country" AND "X-Country" makes the browser
  // send a duplicate header, which Node joins into "ZM, ZM" — that fails
  // normalizeCountry() on the server and silently falls back to UG.
  config.headers["x-country"] = COUNTRY;

  if (isLocalApiRequest(config) && !hasCountryQuery(config.url)) {
    if (config.params instanceof URLSearchParams) {
      if (!config.params.has("country")) config.params.set("country", COUNTRY);
    } else {
      config.params = {
        ...(config.params || {}),
        country: config.params?.country || COUNTRY,
      };
    }
  }

  return config;
};

export const publicRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Public (unauthenticated) calls still identify their market to the shared
// backend so lusuku.co.zm resolves to ZM at the edge (host/header mapping).
publicRequest.interceptors.request.use((config) => {
  return withMarketScope(config);
});

userRequest.interceptors.request.use((config) => {
  withMarketScope(config);
  try {
    const raw = localStorage.getItem("persist:user");
    if (raw) {
      const persisted = JSON.parse(raw);
      const currentUser = persisted.currentUser && JSON.parse(persisted.currentUser);
      if (currentUser) {
        // Phone / Google auth: accessToken at top level
        // Email auth: token at top level or nested in result
        const token =
          currentUser.accessToken ||
          currentUser.token ||
          currentUser.result?.token ||
          currentUser.result?.accessToken;
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
      }
    }
  } catch (_) {}
  return config;
});
